import { render, staticRenderFns } from "./BaseTableDataCol.vue?vue&type=template&id=537584b1&"
import script from "./BaseTableDataCol.vue?vue&type=script&lang=js&"
export * from "./BaseTableDataCol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports